import { Form } from "antd";
import TextArea from "antd/es/input/TextArea";
import React from "react";

const SubjectAddress: React.FC = () => {
  return (
    <Form.Item name="address" label="Address">
      <TextArea />
    </Form.Item>
  );
};

export default SubjectAddress;
